import { render, staticRenderFns } from "./AppTabConfigElementForm.vue?vue&type=template&id=6c1fd956&scoped=true&"
import script from "./AppTabConfigElementForm.vue?vue&type=script&lang=js&"
export * from "./AppTabConfigElementForm.vue?vue&type=script&lang=js&"
import style0 from "./AppTabConfigElementForm.vue?vue&type=style&index=0&id=6c1fd956&scoped=true&lang=css&"
import style1 from "./AppTabConfigElementForm.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1fd956",
  null
  
)

export default component.exports